// GÖVDELİ BİTKİLER PART 2 - bitkiVeritabani2.js
// Mid Tech sonu + High Tech (43 bitki)

export const govdeliBitkilerPart2 = [
  // ==================== MID TECH (devam) ====================
  {
    id: 'micranthemum-umbrosum',
    isim: 'Gölge Micranthemum',
    latince: 'Micranthemum umbrosum',
    resim: '/images/bitkiler/micranthemum-umbrosum.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '10-25 cm',
    genislik: '5-10 cm',
    sicaklik: '20-26°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Küçük yuvarlak yapraklı, yoğun büyüyen bitki.'
  },
  {
    id: 'hemianthus-micranthemoides',
    isim: 'İnci Otu',
    latince: 'Hemianthus micranthemoides',
    resim: '/images/bitkiler/hemianthus-micranthemoides.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '10-20 cm',
    genislik: '5-10 cm',
    sicaklik: '20-26°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Ön - Orta plan',
    aciklama: 'Çok küçük yapraklı, yoğun çalı formunda büyür.'
  },
  {
    id: 'juncus-repens',
    isim: 'Sürünen Kofa',
    latince: 'Juncus repens',
    resim: '/images/bitkiler/juncus-repens.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '10-30 cm',
    genislik: '5-10 cm',
    sicaklik: '18-26°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Çim benzeri görünümü ile farklı bir doku sağlar.'
  },
  {
    id: 'mayaca-fluviatilis',
    isim: 'Yosun Çiçeği',
    latince: 'Mayaca fluviatilis',
    resim: '/images/bitkiler/mayaca-fluviatilis.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Amerika',
    uzunluk: '20-40 cm',
    genislik: '3-5 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'İnce iğne yapraklı, zarif görünümlü bitki.'
  },
  {
    id: 'myriophyllum-aquaticum',
    isim: 'Papağan Tüyü',
    latince: 'Myriophyllum aquaticum',
    resim: '/images/bitkiler/myriophyllum-aquaticum.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güney Amerika',
    uzunluk: '30-60 cm',
    genislik: '5-8 cm',
    sicaklik: '18-26°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Arka plan',
    aciklama: 'Tüy gibi ince yaprakları ile çok dekoratif.'
  },
  {
    id: 'myriophyllum-mattogrossense',
    isim: 'Mattogrosso Milfoil',
    latince: 'Myriophyllum mattogrossense',
    resim: '/images/bitkiler/myriophyllum-mattogrossense.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güney Amerika',
    uzunluk: '30-60 cm',
    genislik: '5-8 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Arka plan',
    aciklama: 'Kırmızımsı tonlu tüylü yapraklar.'
  },
  {
    id: 'myriophyllum-mezianum',
    isim: 'Mezianum Milfoil',
    latince: 'Myriophyllum mezianum',
    resim: '/images/bitkiler/myriophyllum-mezianum.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Brezilya',
    uzunluk: '20-40 cm',
    genislik: '4-6 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'İnce tüylü yapraklı, zarif bitki.'
  },
  {
    id: 'ranunculus-inundatus',
    isim: 'Nehir Düğün Çiçeği',
    latince: 'Ranunculus inundatus',
    resim: '/images/bitkiler/ranunculus-inundatus.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Avustralya',
    uzunluk: '5-15 cm',
    genislik: '5-10 cm',
    sicaklik: '18-26°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Orta',
    konum: 'Ön - Orta plan',
    aciklama: 'Parçalı yaprakları ile ilginç doku sağlar.'
  },
  {
    id: 'marsilea-hirsuta',
    isim: 'Dört Yapraklı Yonca',
    latince: 'Marsilea hirsuta',
    resim: '/images/bitkiler/marsilea-hirsuta.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Avustralya',
    uzunluk: '2-10 cm',
    genislik: '5-15 cm',
    sicaklik: '20-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan',
    aciklama: 'Yonca yapraklı zemin kaplama bitkisi.'
  },
  {
    id: 'lilaeopsis-brasiliensis',
    isim: 'Brezilya Mikro Kılıç',
    latince: 'Lilaeopsis brasiliensis',
    resim: '/images/bitkiler/lilaeopsis-brasiliensis.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güney Amerika',
    uzunluk: '4-8 cm',
    genislik: '5-15 cm',
    sicaklik: '20-26°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan',
    aciklama: 'Çim benzeri görünümü ile doğal halı etkisi.'
  },
  {
    id: 'lilaeopsis-mauritiana',
    isim: 'Mauritius Mikro Kılıç',
    latince: 'Lilaeopsis mauritiana',
    resim: '/images/bitkiler/lilaeopsis-mauritiana.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Mauritius',
    uzunluk: '5-10 cm',
    genislik: '5-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan',
    aciklama: 'Diğer Lilaeopsis türlerinden biraz daha uzun.'
  },

  // ==================== HIGH TECH ====================
  {
    id: 'rotala-macrandra',
    isim: 'Dev Kırmızı Rotala',
    latince: 'Rotala macrandra',
    resim: '/images/bitkiler/rotala-macrandra.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Hindistan',
    uzunluk: '20-40 cm',
    genislik: '3-5 cm',
    sicaklik: '24-30°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Zor',
    konum: 'Orta - Arka plan',
    aciklama: 'En güzel kırmızı bitkilerden biri. Yüksek bakım gerektirir.'
  },
  {
    id: 'rotala-macrandra-green',
    isim: 'Yeşil Macrandra',
    latince: 'Rotala macrandra Green',
    resim: '/images/bitkiler/rotala-macrandra-green.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Hindistan',
    uzunluk: '20-40 cm',
    genislik: '3-5 cm',
    sicaklik: '24-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Zor',
    konum: 'Orta - Arka plan',
    aciklama: 'Yeşil versiyonu, kırmızıdan biraz daha kolay.'
  },
  {
    id: 'rotala-macrandra-narrow-leaf',
    isim: 'Dar Yapraklı Macrandra',
    latince: 'Rotala macrandra Narrow Leaf',
    resim: '/images/bitkiler/rotala-macrandra-narrow-leaf.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Hindistan',
    uzunluk: '15-30 cm',
    genislik: '2-4 cm',
    sicaklik: '24-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Zor',
    konum: 'Orta plan',
    aciklama: 'İnce uzun yapraklı varyant.'
  },
  {
    id: 'rotala-macrandra-variegated',
    isim: 'Alacalı Macrandra',
    latince: 'Rotala macrandra Variegated',
    resim: '/images/bitkiler/rotala-macrandra-variegated.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Hindistan (Kültür formu)',
    uzunluk: '15-30 cm',
    genislik: '3-5 cm',
    sicaklik: '24-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Çok yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Çok zor',
    konum: 'Orta plan',
    aciklama: 'Pembe-beyaz alacalı yapraklar. Çok zor bakım.'
  },
  {
    id: 'rotala-wallichii',
    isim: 'Whorly Rotala',
    latince: 'Rotala wallichii',
    resim: '/images/bitkiler/rotala-wallichii.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '15-30 cm',
    genislik: '3-5 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Zor',
    konum: 'Orta - Arka plan',
    aciklama: 'İğne yapraklı, pembe uçlu zarif bitki.'
  },
  {
    id: 'rotala-mexicana-araguaia',
    isim: 'Araguaia Rotala',
    latince: 'Rotala mexicana Araguaia',
    resim: '/images/bitkiler/rotala-mexicana-araguaia.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Brezilya',
    uzunluk: '10-20 cm',
    genislik: '2-4 cm',
    sicaklik: '24-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Zor',
    konum: 'Orta plan',
    aciklama: 'Kırmızı-pembe renkli, ince yapraklı.'
  },
  {
    id: 'rotala-mexicana-goias',
    isim: 'Goias Rotala',
    latince: 'Rotala mexicana Goias',
    resim: '/images/bitkiler/rotala-mexicana-goias.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Brezilya',
    uzunluk: '10-20 cm',
    genislik: '2-4 cm',
    sicaklik: '24-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Zor',
    konum: 'Orta plan',
    aciklama: 'Yoğun kırmızı renkli nadir tür.'
  },
  {
    id: 'myriophyllum-tuberculatum',
    isim: 'Kırmızı Milfoil',
    latince: 'Myriophyllum tuberculatum',
    resim: '/images/bitkiler/myriophyllum-tuberculatum.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Asya',
    uzunluk: '30-60 cm',
    genislik: '5-8 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Orta - Zor',
    konum: 'Arka plan',
    aciklama: 'Parlak kırmızı tüylü yaprakları ile göz alıcı.'
  },
  {
    id: 'ludwigia-inclinata-cuba',
    isim: 'Küba Ludwigiası',
    latince: 'Ludwigia inclinata var. Cuba',
    resim: '/images/bitkiler/ludwigia-inclinata-cuba.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Küba',
    uzunluk: '15-30 cm',
    genislik: '5-10 cm',
    sicaklik: '24-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Çok yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Çok zor',
    konum: 'Orta - Arka plan',
    aciklama: 'Sarı-turuncu-kırmızı renkleri ile muhteşem.'
  },
  {
    id: 'ludwigia-inclinata',
    isim: 'Eğik Ludwigia',
    latince: 'Ludwigia inclinata',
    resim: '/images/bitkiler/ludwigia-inclinata.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Güney Amerika',
    uzunluk: '20-40 cm',
    genislik: '5-8 cm',
    sicaklik: '24-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Zor',
    konum: 'Orta - Arka plan',
    aciklama: 'Kırmızı-turuncu tonlu geniş yapraklı.'
  },
  {
    id: 'ludwigia-inclinata-araguaia',
    isim: 'Araguaia Ludwigia',
    latince: 'Ludwigia inclinata var. verticillata Araguaia',
    resim: '/images/bitkiler/ludwigia-inclinata-araguaia.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Brezilya',
    uzunluk: '15-30 cm',
    genislik: '5-8 cm',
    sicaklik: '24-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Zor',
    konum: 'Orta plan',
    aciklama: 'Kırmızı-pembe renklerde, çok dekoratif.'
  },
  {
    id: 'ludwigia-inclinata-pantanal',
    isim: 'Pantanal Ludwigia',
    latince: 'Ludwigia inclinata var. verticillata Pantanal',
    resim: '/images/bitkiler/ludwigia-inclinata-pantanal.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Brezilya',
    uzunluk: '15-30 cm',
    genislik: '5-10 cm',
    sicaklik: '24-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Çok yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Çok zor',
    konum: 'Orta plan',
    aciklama: 'Sarı-kırmızı renklerde muhteşem bitki.'
  },
  {
    id: 'ludwigia-glandulosa',
    isim: 'Bezli Ludwigia',
    latince: 'Ludwigia glandulosa',
    resim: '/images/bitkiler/ludwigia-glandulosa.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '20-40 cm',
    genislik: '8-12 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Zor',
    konum: 'Orta - Arka plan',
    aciklama: 'Koyu kırmızı-bordo geniş yapraklar.'
  },
  {
    id: 'alternanthera-reineckii',
    isim: 'Kırmızı Alternanthera',
    latince: 'Alternanthera reineckii',
    resim: '/images/bitkiler/alternanthera-reineckii.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Güney Amerika',
    uzunluk: '25-50 cm',
    genislik: '10-15 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta - Zor',
    konum: 'Orta - Arka plan',
    aciklama: 'Popüler kırmızı bitki. Yüksek ışık ve CO2 ile parlak kırmızı.'
  },
  {
    id: 'alternanthera-reineckii-lilacina',
    isim: 'Leylak Alternanthera',
    latince: 'Alternanthera reineckii Lilacina',
    resim: '/images/bitkiler/alternanthera-reineckii-lilacina.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Güney Amerika',
    uzunluk: '20-40 cm',
    genislik: '8-12 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta - Zor',
    konum: 'Orta - Arka plan',
    aciklama: 'Mor-leylak tonlarında yapraklar.'
  },
  {
    id: 'alternanthera-reineckii-pink',
    isim: 'Pembe Alternanthera',
    latince: 'Alternanthera reineckii Pink',
    resim: '/images/bitkiler/alternanthera-reineckii-pink.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Güney Amerika',
    uzunluk: '20-40 cm',
    genislik: '8-12 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta - Zor',
    konum: 'Orta - Arka plan',
    aciklama: 'Parlak pembe yapraklı çeşit.'
  },
  {
    id: 'alternanthera-sessilis',
    isim: 'Rubra Alternanthera',
    latince: 'Alternanthera sessilis',
    resim: '/images/bitkiler/alternanthera-sessilis.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Pantropik',
    uzunluk: '20-40 cm',
    genislik: '8-12 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Kırmızı-yeşil yapraklı, nispeten kolay.'
  },
  {
    id: 'ammannia-gracilis',
    isim: 'İnce Ammannia',
    latince: 'Ammannia gracilis',
    resim: '/images/bitkiler/ammannia-gracilis.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Afrika',
    uzunluk: '25-50 cm',
    genislik: '8-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Orta - Zor',
    konum: 'Arka plan',
    aciklama: 'Yüksek ışıkta kırmızı-turuncu renkler.'
  },
  {
    id: 'ammannia-crassicaulis',
    isim: 'Kalın Gövdeli Ammannia',
    latince: 'Ammannia crassicaulis',
    resim: '/images/bitkiler/ammannia-crassicaulis.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Afrika',
    uzunluk: '30-60 cm',
    genislik: '10-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Zor',
    konum: 'Arka plan',
    aciklama: 'Büyük kırmızı-turuncu yapraklı gösterişli bitki.'
  },
  {
    id: 'ammannia-pedicellata',
    isim: 'Saplı Ammannia',
    latince: 'Ammannia pedicellata',
    resim: '/images/bitkiler/ammannia-pedicellata.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Afrika',
    uzunluk: '20-40 cm',
    genislik: '8-12 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Zor',
    konum: 'Orta - Arka plan',
    aciklama: 'Kırmızı yapraklı, kompakt büyüyen.'
  },
  {
    id: 'ammannia-senegalensis',
    isim: 'Senegal Ammanniası',
    latince: 'Ammannia senegalensis',
    resim: '/images/bitkiler/ammannia-senegalensis.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Afrika',
    uzunluk: '20-40 cm',
    genislik: '5-10 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Zor',
    konum: 'Orta - Arka plan',
    aciklama: 'Bakır-kırmızı tonlarda dar yapraklar.'
  },
  {
    id: 'cabomba-furcata',
    isim: 'Kırmızı Cabomba',
    latince: 'Cabomba furcata',
    resim: '/images/bitkiler/cabomba-furcata.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Güney Amerika',
    uzunluk: '30-80 cm',
    genislik: '5-8 cm',
    sicaklik: '24-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Zor',
    konum: 'Arka plan',
    aciklama: 'Kırmızı-mor tüylü yaprakları ile çok dekoratif.'
  },
  {
    id: 'pogostemon-stellata',
    isim: 'Yıldız Pogostemon',
    latince: 'Pogostemon stellata',
    resim: '/images/bitkiler/pogostemon-stellata.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '20-60 cm',
    genislik: '8-15 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Zor',
    konum: 'Arka plan',
    aciklama: 'Yıldız şeklinde yaprak dizilimi, mor-yeşil renk.'
  },
  {
    id: 'hemianthus-callitrichoides-cuba',
    isim: 'HC Cuba (Cüce Gözyaşı)',
    latince: 'Hemianthus callitrichoides Cuba',
    resim: '/images/bitkiler/hemianthus-callitrichoides-cuba.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Küba',
    uzunluk: '1-3 cm',
    genislik: '5-15 cm',
    sicaklik: '20-28°C',
    ph: '5.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Zor',
    konum: 'Ön plan',
    aciklama: 'En küçük akvaryum bitkisi. Mükemmel halı etkisi oluşturur.'
  },
  {
    id: 'glossostigma-elatinoides',
    isim: 'Glosso',
    latince: 'Glossostigma elatinoides',
    resim: '/images/bitkiler/glossostigma-elatinoides.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Avustralya, Yeni Zelanda',
    uzunluk: '1-3 cm',
    genislik: '5-15 cm',
    sicaklik: '20-26°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Çok yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Zor',
    konum: 'Ön plan',
    aciklama: 'Popüler zemin kaplama bitkisi. Çok yüksek ışık gerektirir.'
  },
  {
    id: 'utricularia-graminifolia',
    isim: 'UG (Çim Yapraklı)',
    latince: 'Utricularia graminifolia',
    resim: '/images/bitkiler/utricularia-graminifolia.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '2-8 cm',
    genislik: '5-20 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Zor',
    konum: 'Ön plan',
    aciklama: 'Çim görünümlü etobur bitki. Zarif halı oluşturur.'
  },
  {
    id: 'tonina-fluviatilis',
    isim: 'Tonina',
    latince: 'Tonina fluviatilis',
    resim: '/images/bitkiler/tonina-fluviatilis.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Güney Amerika',
    uzunluk: '15-30 cm',
    genislik: '3-5 cm',
    sicaklik: '22-28°C',
    ph: '4.5-6.5',
    sertlik: 'Çok yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Çok zor',
    konum: 'Orta plan',
    aciklama: 'Yıldız şeklinde yaprakları ile benzersiz. Çok asit su gerektirir.'
  },
  {
    id: 'proserpinaca-palustris-cuba',
    isim: 'Küba Deniz Kızı',
    latince: 'Proserpinaca palustris Cuba',
    resim: '/images/bitkiler/proserpinaca-palustris-cuba.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Küba',
    uzunluk: '10-25 cm',
    genislik: '5-10 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Zor',
    konum: 'Orta plan',
    aciklama: 'Testere dişli kırmızı-turuncu yapraklar.'
  },
  {
    id: 'cuphea-anagalloidea',
    isim: 'Araguaia Cuphea',
    latince: 'Cuphea anagalloidea',
    resim: '/images/bitkiler/cuphea-anagalloidea.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Brezilya',
    uzunluk: '10-25 cm',
    genislik: '2-4 cm',
    sicaklik: '24-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Zor',
    konum: 'Orta plan',
    aciklama: 'Kırmızı-pembe ince yapraklı nadir tür.'
  },
  {
    id: 'eriocaulon-cinereum',
    isim: 'Eriocaulon',
    latince: 'Eriocaulon cinereum',
    resim: '/images/bitkiler/eriocaulon-cinereum.jpg',
    kategori: 'Gövdeli Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Asya',
    uzunluk: '5-15 cm',
    genislik: '5-10 cm',
    sicaklik: '22-28°C',
    ph: '5.0-6.5',
    sertlik: 'Çok yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Çok zor',
    konum: 'Ön - Orta plan',
    aciklama: 'Rozet formlu, çok yumuşak asit su gerektirir.'
  }
];

export default govdeliBitkilerPart2;